<template>
    <div class="bk-literature-main">
        <a-spin :spinning="spinning" size="large">
        <bkNav fontColor="yl" @bkSearchShow="bkSearchShow" @bkSearchHide="bkSearchHide"></bkNav>
        <!-- <div :class="bkSearchTabShow ? 'lt-taps cur' : 'lt-taps'"> -->
        <div :class="bkSearchTabShow ? 'lt-taps cur' : 'lt-taps'">
            <div class="taps">
                <span :class="pageTab===0?'cur':''" @click="changeTab(0)">近代报纸</span>
                <span :class="pageTab===1?'cur':''" @click="changeTab(1)">近代期刊</span>
            </div>
            <div class="ipts">
                <div class="ipt">
                    <span>题名</span>
                    <a-input v-model="TI" placeholder="请输入题名" allow-clear @pressEnter="advancedSearch" @change="onInputChange"/>
                    <!-- <input type="text" v-model="TI" @keyup.enter="advancedSearch"> -->
                </div>
                <div class="ipt">
                    <span>创建时间</span>
                    <a-input v-model="SJ" placeholder="请输入年份" allow-clear @pressEnter="advancedSearch" @change="onInputChange"/>
                    <!-- <a-date-picker @panelChange="onPanelChange" @change="onPanelChange" @openChange="onOpenChange"
                        v-model="SJ" :open="isDateOpen" :defaultPickerValue="$moment('1920')"
                        :format="dateFormat" :inputReadOnly="true"
                        :mode="dateMode" placeholder="请选择年份"
                    /> -->
                </div>
                <div class="ipt">
                    <span>出版社</span>
                    <a-input v-model="PB" placeholder="请输入出版社" allow-clear @pressEnter="advancedSearch" @change="onInputChange"/>
                </div>
                <div class="ipt">
                    <span>出版地</span>
                    <a-input v-model="PP" placeholder="请输入出版地" allow-clear @pressEnter="advancedSearch" @change="onInputChange"/>
                </div>
            </div>
        </div>
        <div :class="bkSearchTabShow ? 'letter-nav cur' : 'letter-nav'">
            <span>字母导航</span>
            <a href="javascript:" :class="letterCurrent==='全部'?'all cur':'all'" @click="changeLetter('全部')">全部</a>
            <a href="javascript:" v-for="l in letters" :key="l" :class="letterCurrent===l?'cur':''" @click="changeLetter(l)">{{l}}</a>
        </div>
        <div :class="bkSearchTabShow ? 'result cur' : 'result'">
            <div class="tit">
                <span>
                    <b>{{litePageTotal}}</b>个搜索结果
                </span>
                <div class="st">
                    <div href="javascript:" class="sort-img"> <img src="./../searchResult/img/sort.png" alt=""> 排序</div>
                    <div class="sort">
                        <!-- <span class="star"></span> -->
                        <select @change="sort" v-model="sortRule">
                            <option value="0">降序</option>
                            <option value="1">顺序</option>
                        </select>
                        <select class="lg" v-model="lg" @change="sort">
                            <option value="TI">{{JDBK}}</option>
                            <option value="SJ">创建时间</option>
                        </select>
                    </div>
                    <a href="javascript:" @click="onExport"><img src="./../searchResult/img/icon4.png" alt=""> 导出</a>
                </div>
            </div>
            <table>
                <tr class="thead">
                    <th>{{thTitle}}</th>
                    <th>{{thCreated}}</th>
                    <th>{{thPublisher}}</th>
                    <th>{{thProvisionActivity}}</th>
                </tr>
                <tbody v-if="litePageList && litePageList.length > 0">
                    <tr v-for="(item, index) in litePageList" :key="'n'+index">
                        <td><a href="javascript:;" @click="literatureTitle(item)">{{item.titleChs}}</a></td>
                        <td>{{item.created || arrayToString(item.temporalCollected, 'year', ' ')}}</td>
                        <td>{{listUniqToString(item.publisher, 'name', ' ') || arrayToString(item.publisher, 'publisher', ' ')}}</td>
                        <td>{{listUniqToString(item.provisionActivity, 'place.chsPlc', ' ')}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="pages">
                <!-- :showTotal="(total, range)=> `共 ${total} 条`" -->
                <a-pagination 
                    v-model="litePageth"
                    show-quick-jumper
                    :default-current="1"
                    :total="litePageTotal"
                    :defaultPageSize="litePageSize"
                    @change="onPageChange"
                />
            </div>
        </div>
        </a-spin>
    </div>
</template>

<script>
    import bkNav from './../nav'
    import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
    export default {
        components:{
            bkNav
        },
        data(){
            return{
                locale,
                dateMode: 'year',
                dateFormat: 'YYYY',
                isDateOpen: false,
                spinning: false, // 加载中...
                bkSearchTabShow: false,
                pageTab:0,  // 0：报，1：刊
                thTitle             : '报纸名',
                thCreated           : '创建时间',
                thPublisher         : '出版社',
                thProvisionActivity : '出版地',
                letterCurrent:'全部',
                letters:['A',"B","C","D","E","F",'G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
                searchType: 1,     // 1：简单检索，2：高级检索，3：专业检索
                keyword: "",       // 简单检索参数
                // cdtn: [],       // 高级检索参数
                expression: "",    // 专业检索参数
                newspaperList: [], // 报数据
                newspaperSize: 0,  // 报数目
                magazineList: [],  // 刊数据
                magazineSize: 0,   // 刊数目
                litePageList: [],  // 页面显示数据
                litePageTotal: 0,  // 总数目
                litePageth: 1,     // 第几页
                litePageSize: 10,  // 每页显示数量
                exportList  : [],  // 导出数据
                isNotExport: true, // true：非导出，false：导出
                TI: "", // 题名
                SJ: "", // 创建时间
                PB: "", // 出版社
                PP: "", // 出版地
                PY: "", // 字母
                sortsSJ: 0,  // 时间排序
                sortRule: 0, // 排序规则
                lg: "SJ",    // 排序的属性
                JDBK: "报名",
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.iframeFunc();
                // this.getNewspaperSearch();
                // this.sort();
            })
        },
        methods:{
            bkSearchShow(visible){ // 高级检索框显示
                this.bkSearchTabShow = visible;
                this.unScroll(); // 禁止滚动条滚动
            },
            bkSearchHide(visible){ // 高级检索框隐藏
                this.bkSearchTabShow = visible;
                this.removeUnScroll(); // 移除禁止滚动条滚动
            },
            init(){
                this.litePageList  = [];
                this.litePageTotal = 0;
                this.TI = ""; // 题名
                this.SJ = ""; // 创建事件
                this.PB = ""; // 出版社
                this.PP = ""; // 出版地
                this.PY = ""; // 字母
                this.sortsSJ = 0; // 时间排序
            },
            literatureTitle(item){
                let _detailObj = {};
                switch (this.pageTab) {
                    case 0: // 报详情跳转
                        _detailObj = {
                            source: '近代报纸',
                            url:'//dhc.library.sh.cn/bk/newspaperDetail',
                            litIndex: 0,
                        };
                        localStorage.newspaperURI = item['@id'];
                        this.$router.push("/bk/newspaperDetail");
                        break;
                    case 1: // 刊详情跳转
                        _detailObj = {
                            source: '近代期刊',
                            url:'//dhc.library.sh.cn/bk/magazineDetail',
                            litIndex: 1,
                        };
                        localStorage.magazineURI = item['@id'];
                        this.$router.push("/bk/magazineDetail");
                        break;
                    default:
                        break;
                }

                // 浏览历史埋点START
                if(this.activeUserInfo){
                    this.browseHistory({
                        title   : item.titleChs,
                        subTitle: "无", // 子标题
                        content : "报刊库检索",   // 报刊库检索列表
                        image: "",
                        url  : _detailObj.url+'?uri='+item['@id'],
                        releaseType: "B",
                        sourceType: {
                            id  : "https://dhc.library.sh.cn/bk/literature?litIndex="+_detailObj.litIndex,
                            name: _detailObj.source,
                        },
                        dataType: {
                            id  : "https://dhc.library.sh.cn/bk/home",
                            name: "近代报刊库",
                        },
                        source: {
                            id  : "https://dhc.library.sh.cn/bk/literature?litIndex="+_detailObj.litIndex,
                            name: _detailObj.source,
                        }
                    });
                }
                // 浏览历史埋点END
            },
            async sort(){ // 排序
                this.params.sorts = {};
                this.params.sorts[this.lg] = this.sortRule;
                await this.searchTab();
            },
            advancedSearch(){ // 高级检索
                this.litePageth = 1;
                this.searchType = 2;
                this.searchTab();
            },
            onInputChange(e){ // 输入框清空
                if(e.type == 'click') this.advancedSearch();
            },
            onPanelChange(date){ // 日期面板变化-->年份选择
                this.SJ = date;
                this.isDateOpen = false;
                // console.log(this.$moment(date).format("YYYY"));
                this.advancedSearch();
            },
            onOpenChange(status){ // 弹出日历和关闭日历
                if(status) this.isDateOpen = status;
                else this.isDateOpen = status;
            },
            showListData(){ // 页面显示数据
                this.litePageList = this.pageTab == 0 ? this.newspaperList : this.magazineList;
                this.litePageTotal = this.pageTab == 0 ? this.newspaperSize : this.magazineSize;
            },
            changeLetter(a){ // 字母点击
                this.litePageth = 1;
                this.searchType = 2;
                this.letterCurrent=a;
                this.PY = a;
                if(a == "全部") this.PY = "";
                this.searchTab();
            },
            changeTab(a){ // 报刊、期刊切换
                this.pageTab = a;
                this.thTitle = a==0 ? '报纸名' : '期刊名';
                this.JDBK    = a==0 ? '报名'   : '刊名';
                this.init();
                this.litePageth = 1;
                this.letterCurrent = "全部";
                this.searchTab();
            },
            onPageChange(pageNumber){
                this.litePageth = pageNumber;
                this.searchTab();
            },
            getUrlHistoryParams(){ // 获取地址栏历史检索参数
                let _historyParams = this.getZhUrlParam('historyParams');
                if(_historyParams && !this.isEmpty(_historyParams)) {
                    let _hisParams  = JSON.parse(decodeURIComponent(_historyParams));
                    this.pageTab    = _hisParams.litIndex;
                    this.searchType = _hisParams.searchType;

                    let _hisParamsCdtn = _hisParams.cdtn;
                    for(let index in _hisParamsCdtn) {
                        let _object = _hisParamsCdtn[index];
                        if(!this.isEmpty(_object.value)) {
                            this[_object.field] = _object.value;
                            if(_object.field == 'PY') this.letterCurrent = _object.value;
                        }
                    }
                    return _hisParams;
                }
                return null;
            },
            iframeFunc(){ // 详情页跳转当前页面时
                // 检索历史跳转
                let _historyParams = this.getUrlHistoryParams();
                if( this.isEmptyObject(_historyParams) ){
                    this.pageTab = Number( this.getUrlParam('litIndex') );
                    if( this.pageTab!=0 && this.pageTab!=1 ){
                        this.pageTab = Number(localStorage.iframeIndex);
                        if( this.pageTab!=0 && this.pageTab!=1 ){
                            this.pageTab = 0;
                            let params = this.$route.params;
                            if( !this.isEmptyObject(params) && !this.isEmpty(params.iframeIndex) ){
                                this.pageTab = JSON.parse(decodeURIComponent(this.$route.params.iframeIndex));
                                // this.searchTab();
                            }
                        }
                    }
                }
                window.localStorage.removeItem('iframeIndex');
                this.sort();
                this.replaceUrl2('?historyParams='); // 无刷新，改变地址栏
            },
            async searchTab(){
                switch (this.pageTab) {
                    case 0:
                        await this.getNewspaperSearch();
                        break;
                    case 1:
                        await this.getMagazineSearch();
                        break;
                    default:
                        break;
                }
            },
            async getNewspaperSearch(){ // 报
                this.spinning = true; // 加载中...
                await this.$axios.post(this.bkCommon.newspaperSearchUrl, this.params)
                .then((res) => {
                    let resultData = res.data;
                    if(this.isNotExport) {
                        this.newspaperList = resultData.datas;
                        this.newspaperSize = resultData.pager.rowCount;
                        this.showListData();
                    }
                    else this.exportList = resultData.datas; // 导出时数据
                    this.isNotExport = true;
                    this.spinning = false; // 加载结束
                })
                .catch((err) => {
                    console.log(err)
                });
                // 检索埋点START
                if(this.Common.userInfo) {
                    this.params.litIndex = 0;
                    this.createUserLog("https://dhc.library.sh.cn/bk/literature", this.params, "近代报刊库-报纸检索")
                }
                // 检索埋点END
            },
            async getMagazineSearch(){ // 刊
                this.spinning = true; // 加载中...
                await this.$axios.post(this.bkCommon.magazineSearchUrl, this.params)
                .then((res) => {
                    let resultData = res.data;
                    if(this.isNotExport) {
                        this.magazineList = resultData.datas;
                        this.magazineSize = resultData.pager.rowCount;
                        this.showListData();
                    }
                    else this.exportList = resultData.datas; // 导出时数据
                    this.isNotExport = true;
                    this.spinning = false; // 加载结束
                })
                .catch((err) => {
                    console.log(err)
                });
                // 检索埋点START
                if(this.Common.userInfo) {
                    this.params.litIndex = 1;
                    this.createUserLog("https://dhc.library.sh.cn/bk/literature", this.params, "近代报刊库-期刊检索")
                }
                // 检索埋点END
            },
            async onExport(){ // 导出
                let _this = this;
                _this.isNotExport  = false; // 导出
                if(_this.litePageTotal <= 10) {
                    await _this.sort(); // 重新获取数据
                    _this.onResultExport();
                    return;
                }
                _this.$Modal.confirm({
                    title           : '导出',
                    content         : '每种文献最多导出100条数据，是否继续？',
                    cancelText      : '取消',
                    okText          : '确定',
                    confirmLoading  : false,
                    onCancel() { }, // 取消
                    async onOk() {  // 确定
                        // _this.$loading.show("正在导出...");
                        _this.litePageSize = 100;
                        await _this.sort(); // 重新获取数据
                        _this.onResultExport();
                        // _this.$loading.hide();
                    },
                });
            },
            onResultExport(){ // 导出内容设置
                let _this = this;
                _this.litePageSize = 10;
                let title      = [];     // csv文档标题
                let exportData = [];     // csv文档数据
                let fileName   = 'temp'; // 文件名
                let titleArr   = [
                    {ch:'报纸名',   en:"titleChs"}, 
                    {ch:'创建时间', en:"created"}, 
                    {ch:'出版社',   en:"publisher"}, 
                    {ch:'出版地',   en:"place"}, 
                    {ch:'文献类型', en:"source"}, 
                    {ch:'资源uri',  en:"uri"}
                ]; // 文档标题集合
                if(this.pageTab == 1) titleArr[0].ch = '期刊名';
                titleArr.forEach((item) => {
                    title.push({title: item.ch  , field: item.en});  // 设置标题
                })
                exportData = _this.onCsvExportData();
                _this.JSONToExcelConvertor(title, exportData, fileName); // 导出csv文件
            },
            onCsvExportData(){ // csv导出数据处理
                let exportData = [];
                for(let i=0, len=this.exportList.length; i<len; i++){
                    let item = this.exportList[i];
                    exportData.push({
                        titleChs    : item.titleChs,
                        created     : item.created || this.arrayToString(item.temporalCollected, 'year', ' '),
                        publisher   : this.listUniqToString(item.publisher, 'name', ' ') || this.arrayToString(item.publisher, 'publisher', ' '),
                        place       : this.listUniqToString(item.provisionActivity, 'place.chsPlc', ' '),
                        source      : this.pageTab == 0 ? '近代报纸' : '近代期刊',
                        uri         : item['@id'],
                    })
                }
                return exportData;
            }
        },
        computed: {
            params(){
                return {
                    "searchType": this.searchType,
                    "expression": this.expression,
                    "freetext":   this.keyword,
                    "cdtn":       this.cdtn,
                    "facet": {},
                    "secondCdtn": "",
                    "pager": {
                        "pageth": this.litePageth,
                        "pageSize": this.litePageSize
                    },
                    "sorts": {
                        "SJ": this.sortsSJ
                    },
                    "hasFacet": false
                }
            },
            sjFormat(){
                return Number(this.$moment(this.SJ).format("YYYY"));
            },
            cdtn(){
                return [
                    {
                        "logic": "and",
                        "field": "TI",
                        "value": this.TI,
                        "type": "0"
                    },
                    {
                        "logic": "and",
                        "field": "SJ",
                        "value": this.SJ,
                        "type": "0"
                    },
                    {
                        "logic": "and",
                        "field": "PB",
                        "value": this.PB,
                        "type": "0"
                    },
                    {
                        "logic": "and",
                        "field": "PP",
                        "value": this.PP,
                        "type": "0"
                    },
                    {
                        "logic": "and",
                        "field": "PY",
                        "value": this.PY,
                        "type": "0"
                    }
                ]
            },
            activeUserInfo(){
                return this.Common.userInfo;
            },
        },
        watch: {
            
        }
    }
</script>

<style lang="less" scoped>
tbody{
    span{
        margin-right: 5px;
    }
}

.lt-taps{
    &.cur{
        opacity: 0.1;
    }
    .ipts{
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;
        border-top-right-radius: 7px;
        .ant-input-affix-wrapper{ // 输入框插件
            width: auto;
        }
    }
}
.letter-nav{
    &.cur{
        opacity: 0.1;
    }
}
.result{
    &.cur{
        opacity: 0.1;
    }
    .st{
        .sort-img{
            margin: 0 5px;
            color: #deaf68;
            display: inline-block;
            img{
                max-height: 14px;
                position: relative;
                top: -1px;
            }
        }
        .sort{
            display: inline-block;
            select{
                background: #36498a;
                color: #fff;
                height: 24px;
                min-width: 70px;
                padding: 0 10px;
                border: none;
                box-sizing: border-box;
                resize: none;
                border-radius: 10px;
                outline: none;
                margin-right: 5px;
            }
        }
    }
    /deep/ .pages{
        .ant-pagination-item-active{
            background: rgba(222,175,105;1);
            border-color:rgba(222,175,105;1);
            a{
                color: #fff!important;
            }
        }
        .ant-pagination-item:focus, 
        .ant-pagination-item:hover{
            border-color: rgba(222,175,105;1);
            a{
                color: rgba(222,175,105;1);
            }
        }
        .ant-pagination-prev{
            &:focus{
                .ant-pagination-item-link{
                    color:  rgba(222,175,105;1);
                    border-color:  rgba(222,175,105;1);
                }
            }
            &:hover{
                .ant-pagination-item-link{
                    color:  rgba(222,175,105;1);
                    border-color:  rgba(222,175,105;1);
                }
            }
        }
        .ant-pagination-next{
            &:focus{
                .ant-pagination-item-link{
                    color:  rgba(222,175,105;1);
                    border-color:  rgba(222,175,105;1);
                }
            }
            &:hover{
                .ant-pagination-item-link{
                    color:  rgba(222,175,105;1);
                    border-color:  rgba(222,175,105;1);
                }
            }
        }

        .ant-pagination-jump-prev,
        .ant-pagination-jump-next{
            .ant-pagination-item-container{
                .ant-pagination-item-link-icon{
                    color:rgba(222,175,105;1);
                }
            }
        }

        .ant-pagination-options-quick-jumper {
            input{
                &:hover {
                    border-color: rgba(222,175,105;1);
                }
            }
        }
    }
}
/*这是控制年月日之间的斜线或短横线的*/
// ::-webkit-datetime-edit-month-field,
// ::-webkit-datetime-edit-text {
//     display: none;
// }
// ::-webkit-datetime-edit-day-field {
//     display: none;
// }
</style>